import React, { useState, useEffect } from 'react';
import { PopupBase, Button } from '@spark-labs/avocado-ui';
import { getLicenseAgreement, acceptLicenseAgreement } from '@go-client/lib/api/user';
import { User } from '@go-shared/types/user';

interface LicenseAgreementCheckerProps {
  onLicenseAgreementAccepted: (user: User) => void;
}
export const LicenseAgreementChecker: React.FC<LicenseAgreementCheckerProps> = ({
  onLicenseAgreementAccepted,
}) => {
  const [licenseAgreementText, setLicenseAgreementText] = useState('');
  useEffect(() => {
    (async () => {
      const license = await getLicenseAgreement();
      if (license) {
        setLicenseAgreementText(license.license_text);
      }
    })()
      .then()
      .catch(console.error);
  }, []);

  const handleLicenseAccept = async () => {
    const user = await acceptLicenseAgreement();
    if (user.acceptedLicenseAgreement) {
      onLicenseAgreementAccepted(user);
    }
  };
  return (
    <PopupBase
      onClose={() => {
        /* block is empty tslint fix */
      }}
    >
      <div
        style={{ height: '75vh', width: '50vw' }}
        className="px-5 py-4 flex flex-col justify-betwee"
      >
        <div className="border-b border-grey-light pb-4">
          <h1 className="text-xl font-semibold text-grey-dark">LICENSE AGREEMENT</h1>
        </div>
        <div className="overflow-y-scroll" style={{ flex: 1 }}>
          <div dangerouslySetInnerHTML={{ __html: licenseAgreementText }}></div>
        </div>
        <div className="mt-4 flex justify-end border-t border-grey-light pt-4">
          <span className="mr-5">
            <Button
              className="bg-blue-dark text-white px-4 py-2 rounded-none"
              onClick={handleLicenseAccept}
            >
              Accept
            </Button>
          </span>
        </div>
      </div>
    </PopupBase>
  );
};
